import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { PlaceTableFilterSchema } from "./_list/-zod-schema";

export const Route = createFileRoute("/_staff/places/_layout/")({
  validateSearch: zodValidator(PlaceTableFilterSchema),
});
